import request from 'src/api'

// TODO.md T-111. **The one path a record delete goes through, so clearing `dirty` cannot be forgotten or
// mis-ordered.**
//
// 🚨 **`F-148` was four identical bugs, not one.** All four `#confirmDelete` handlers are bound on the same
// shared `#mainModal`, each deciding by its own ad-hoc page test which one should act, and every one of them
// had to remember `dirty = false` in its success branch. `packs/application.js` reads `dirty` on
// `hide.bs.offcanvas` and clears it on `hidden.bs.offcanvas` — the guard runs **first** — so a record that
// was edited and then deleted raised "you have unsaved changes" over its own success toast. On the customer
// and quality-control paths it is worse: the response navigates, so a stale flag reaches `beforeunload` and
// raises the **browser's** native "leave site?" dialog on a record that no longer exists.
//
// 🔑 **Why a helper rather than one delegated handler.** `delete_clears_dirty_spec` enforced the flag at
// four call sites plus an enumeration example so a fifth could not hide — a lint keeping four copies in
// step, which is the shape `CLAUDE.md` → *Role Guards* calls MANDATORY to avoid. ⚠️ And it could never catch
// the bug it was written for: a handler that clears `dirty` **after** an await satisfies "contains
// `dirty = false`" and is still wrong. Clearing it *here*, before the caller's `.then` runs, makes the
// ordering structural — a fifth delete handler is correct by default.
// 📌 The four success bodies genuinely differ (a toast and a DataTables reload; evaluating a server script
// that navigates; building transfer params), so they stay with their packs. Only the request and the flag
// are shared.
//
// ⚠️ `window.dirty`, spelled out: the packs assign a bare `dirty`, which only reaches the global because
// their compiled output is not strict. In an ES module it would be a `ReferenceError`.
export default function deleteRecord(url, { accept = 'json' } = {}) {
  return request.delete(url)
    .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
    .accept(accept)
    .then((response) => {
      window.dirty = false

      return response
    })
}
